<template>
	<link rel="prefetch" :href="ytThumbLink" :if="ytThumbLink">
</template>
<script>
import youtubeLinks from '../lib/youtubeLinks'

export default {
	name:'prefetchImgThumb',
	props:{
		videoID:{
			default:""
		}
	},
	computed:{
		ytThumbLink: function(){
			if(this.videoID){
				return youtubeLinks.youtubeThumbUrl(this.videoID);
			}
			return false;
		}
	}
}
</script>


// WEBPACK FOOTER //
// prefetchImgThumb.vue?1c7844a5